/**************************
 * App Redux Action types *
 **************************/

//Auth action types
export const AUTH = {
  LOGIN_USER: 'LOGIN_USER',
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  LOGIN_USER_FAILURE: 'LOGIN_USER_FAILURE',
  LOGOUT_USER: 'LOGOUT_USER',
  SIGNUP_USER: 'SIGNUP_USER',
  SIGNUP_USER_SUCCESS: 'SIGNUP_USER_SUCCESS',
  SIGNUP_USER_FAILURE: 'SIGNUP_USER_FAILURE'
}

export const SET_OVERLOADING = 'SET_OVERLOADING';

export const PRODUCTS = {
  PRODUCT_INFORMATION: 'PRODUCT_INFORMATION',
  PRODUCT_CARTS: "PRODUCT_CARTS",
  PRODUCT_ITEM: 'PRODUCT_ITEM'
}

